import { i18n } from '@/commons/utils';

const AN_ITEM = '.one-product';
const ONE_ITEM = '.one-product:not(.returned)';
const ONE_PRODUCT = '.one-product:not(.blocked):not(.returned)';
const ONE_PRODUCT_ACTIVE = '.one-product:not(.blocked):not(.returned).active';
const ONE_PRODUCT_EXCHANGED = '.one-product.exchange';
const SELECTOR_CONTAINER = '#selector-container';
const VIEW_OPEN = 'view-open';
const ALL_PRODUCTS = '.all-products';
const CORE_QUANTITY_BUTTON = '.quantity-selector button.quantity-more, .quantity-selector button.quantity-less';
const A_COLOR = '.exchange-color-selection__model-color';
const REASON_REFUND_MOBILE = '#reason-refund-mobile';
const MODAL_MAKE_CHOICE = '#modal-selector-view-return-choice';
const MODAL_EXCHANGE = '#modal-selector-view-exchange-choice';
const VIEW_EXCHANGE = '#selector-view-exchange-choice';

const SELECT_ITEM = 'rest/model/atg/commerce/custsvc/returns/ReturnsActor/selectItems';
const PREVIEW_SELECT_ITEM = 'rest/model/atg/commerce/custsvc/returns/ReturnsActor/previewSelectItems';
const CANCEL_RETURN = 'rest/model/atg/commerce/custsvc/returns/ReturnsActor/cancelReturnRequest';
const CONFIRM_RETURN = 'rest/model/atg/commerce/custsvc/returns/ReturnsActor/confirmReturn';

export function init() {
  const $this = $('body');

  $(window)
    .on('load', () => {
      checkButtonNext();
      //Set the .all-products container to opacity: 1 when the page is totally loaded
      $(ALL_PRODUCTS).css({ opacity: 1 });
    });

  $this
    .on('click', `${ONE_PRODUCT}:not(.active)`, function handleClick() {
      const $_this = $(this);

      $(ONE_PRODUCT).removeClass('active');

      if (cube.ui.isMobile()) {
        $_this.addClass('active');
        $(REASON_REFUND_MOBILE).selectpicker();
        $(MODAL_MAKE_CHOICE).modal('show');

        const returnQuantityInput = $('#modal-selector-view-return-choice .quantity-input');
        // update quantity selector & select
        returnQuantityInput.data('maxquantity', $('.one-product.active').data('quantity'));
        $('#reason-refund-mobile .selectpicker').selectpicker('refresh');

        if (returnQuantityInput.data('maxquantity') === 1) {
          $('.quantity-more').attr('disabled', 'disabled');
          returnQuantityInput.attr('readonly', 'readonly');
          returnQuantityInput.attr('disabled', 'disabled');
        } else {
          $('.quantity-more').removeAttr('disabled');
          returnQuantityInput.removeAttr('readonly');
          returnQuantityInput.removeAttr('disabled');
        }
      } else {
        const firstView = $_this.attr('data-which-view');
        showMiniView($_this, firstView, $this);
      }
    })
    .on('click', `.${VIEW_OPEN} ${AN_ITEM}`, () => {
      closeMiniView();
    })
    // Destop GOTO refund part
    .on('click', '#goto-refund', (e) => {
      e.preventDefault();
      showMiniView($(ONE_PRODUCT_ACTIVE), 'selector-view-refund-choice', $this);
    })
    // Mobile GOTO refund part
    .on('click', '.goto-mobile-refund', (e) => {
      e.preventDefault();
      const $currentItem = $(ONE_PRODUCT_ACTIVE);
      const quantityInput = $(`${MODAL_MAKE_CHOICE} .quantity-input`);
      $('.modal').modal('hide');
      $('#modal-selector-view-refund-choice').modal('show');
      $currentItem.addClass('active');
      let quantityCurrentItem = quantityInput.val();
      let quantityToReturn = $(ONE_PRODUCT_ACTIVE).attr('data-send-quantity-refund');
      getPriceCurrentItem($this, quantityCurrentItem, quantityToReturn);

      $currentItem.addClass('active');
      quantityCurrentItem = quantityInput.val();
      quantityToReturn = $(ONE_PRODUCT_ACTIVE).attr('data-send-quantity-refund');
      getPriceCurrentItem($this, quantityCurrentItem, quantityToReturn);
    })
    // Mobile GOTO exchange part
    .on('click', '#goto-mobile-exchange', (e) => {
      e.preventDefault();
      const $currentItem = $(ONE_PRODUCT_ACTIVE);
      $('.modal').modal('hide');
      $(MODAL_EXCHANGE).modal('show');
      $currentItem.addClass('active');
      // init lightSlider
      cube.lightSlider.init();
      $(`${A_COLOR  }:first-child`).addClass('exchange-color-selection__model-color--selected');
    })
    .on('click', '#goto-exchange', (e) => {
      e.preventDefault();
      showMiniView($(ONE_PRODUCT_ACTIVE), 'selector-view-exchange-choice', $this);
      // init lightSlider
      cube.lightSlider.init();
      $(`${A_COLOR  }:first-child`).addClass('exchange-color-selection__model-color--selected');
    })
    // EXCHANGE - CLONE HTML FROM THE <ARTICLE> IN THE MODAL
    .on('click', AN_ITEM, function handleClick() {
      const isexchangeable = $(this).attr('data-is-exchangeable');

      if (isexchangeable.toLowerCase() === 'true') {
        // Clone exchange html from the fake modal
        const exchangeContent = $(this).find('.fake-modal').html();
        const baseSelector = cube.ui.isMobile() ? MODAL_EXCHANGE : VIEW_EXCHANGE;

        $(`${baseSelector} .content-exchange`).html(exchangeContent);
        $(`${baseSelector} .exchange-size__list-container`).selectpicker();
        $(`${baseSelector} .exchange-size`).first().addClass('exchange-size--current');
        $(`${baseSelector} #reason-exchange`).selectpicker();
      }
    })
    // EXCHANGE - ADD SELECTED TO THE PRODUCT AND DISPLAY SIZE LIST
    .on('click', A_COLOR, function handleClick() {
      const productId = $(this).attr('data-model-id');

      $(A_COLOR).removeClass('exchange-color-selection__model-color--selected');
      $(this).addClass('exchange-color-selection__model-color--selected');

      $(`${VIEW_EXCHANGE} .exchange-size,${MODAL_EXCHANGE} .exchange-size`)
        .removeClass('exchange-size--current');
      $(`${VIEW_EXCHANGE} #${productId}.exchange-size,${MODAL_EXCHANGE} #${productId}.exchange-size`)
        .addClass('exchange-size--current');
      checkButtonState();
    })
    // EXCHANGE - ADD SELECTED TO THE SIZE LIST
    .on('change', '.exchange-size__list-container', function handleChange() {
      const quantity = $('.exchange-size__list-container .dropdown-menu li.selected .size-selected').attr('data-stockavailable');

      if (quantity > 0) {
        $(this).addClass('selected');
      } else {
        $('.exchange-size__list-container').removeClass('selected');
      }
    })
    // EXCHANGE - ADD SELECTED TO THE REASON LIST
    .on('change', '.reason-exchange', function handleChange() {
      $(this).addClass('selected');
    })
    // EXCHANGE - REMOVE DISABLED CLASS FROM .validateExchangeButton
    .on('change', '.exchange-size__list-container, .reason-exchange', checkButtonState)
    // EXCHANGE - CLICK ON VALIDATE EXCHANGE
    .on('click', `${VIEW_EXCHANGE} .validateExchangeButton.enabled, ${MODAL_EXCHANGE} .validateExchangeButton.enabled`, (e) => {
      e.preventDefault();
      // Gestion quantite + raison de retour
      const currentSkuItem = $('.one-product.active').attr('data-skuid');
      const exchangeItem = $(`.one-product.exchange[data-skuid=${currentSkuItem}]`);
      const sizeSelected = $('.exchange-size--current .exchange-size__list-container button .size-selected');
      const skuToExchange = sizeSelected.attr('data-skuid');
      const skuToExchangeQte = sizeSelected.attr('data-stockavailable');
      let raison = '';
      let qteTotalItem = 0;
      let qteIsAvailable = true;
      let qteToExchange = 0;

      if (cube.ui.isMobile()) {
        const quantitySelectorMobile = $('#product-details-quantity-selector-mobile .quantity-input');
        qteToExchange = quantitySelectorMobile.val() * 1;
        qteTotalItem = quantitySelectorMobile.val() * 1;
        raison = $(`${MODAL_EXCHANGE} #reason-exchange`).selectpicker('val');
      } else {
        const quantitySelector = $('#product-details-quantity-selector .quantity-input');
        qteToExchange = quantitySelector.val() * 1;
        qteTotalItem = quantitySelector.val() * 1;
        raison = $(`${VIEW_EXCHANGE} #reason-exchange`).selectpicker('val');
      }

      if (exchangeItem.length > 0) { // si le produit est dupliqué
        let totalExchanged = 0;

        $(`.one-product.exchange[data-skuid=${currentSkuItem}] .producttoexchange`)
          .each(function checkQuantity() {
            if ($(this).attr('data-replacementSkuId') === skuToExchange) {
              const sameSkuQte = $(this).attr('data-quantitytoexchange') * 1;
              qteToExchange = qteTotalItem + sameSkuQte;
              if (qteToExchange > skuToExchangeQte) {
                qteIsAvailable = false;
                window.pushAlert('danger', 'bell', i18n('return.returnApplication.table.tooLessQuantity', skuToExchangeQte));
                return false;
              }
              $(this).remove();
            }
            totalExchanged += parseInt(`${ $(this).data('quantitytoexchange') }`, 10);
            return true;
          });

        qteTotalItem += totalExchanged;
      } else if (qteTotalItem > skuToExchangeQte) {
        window.pushAlert('danger', 'bell', i18n('return.returnApplication.table.tooLessQuantity', skuToExchangeQte));
        return false;
      }

      if (qteIsAvailable === false) {
        return false;
      }

      // insert data into DOM
      $(ONE_PRODUCT_ACTIVE).attr('data-send-quantity-exchange', qteTotalItem);
      $(ONE_PRODUCT_ACTIVE).attr('data-active-quantity-to-exchange', qteToExchange);
      $(ONE_PRODUCT_ACTIVE).attr('data-send-raison', raison);
      $(ONE_PRODUCT_ACTIVE).attr('data-skuToExchange', skuToExchange);

      // construct map to send
      const data = {
        lines: $this.find(ONE_ITEM),
        exchangeItems: {}
      };
      data.lines.each((index, element) => {
        const product = $(element);
        const skuId = product.attr('data-skuid');
        data.exchangeItems[skuId] = {
          id: product.attr('data-skuid'),
          quantityToExchange: product.attr('data-send-quantity-exchange'),
          quantityToReturn: product.attr('data-send-quantity-refund'),
          returnReason: product.attr('data-send-raison'),
          shippingGroupId: product.attr('data-send-shipping-group')
        };

        if (product.attr('data-send-quantity-exchange') > 0) {
          data.exchangeItems[skuId].exchangeRelations = [];

          data.exchangeItems[skuId].exchangeRelations.push({
            quantity: product.attr('data-active-quantity-to-exchange'),
            replacementSkuId: product.attr('data-skuToExchange'),
            returnReason: product.attr('data-send-raison')
          });
        }

        $(`${ONE_PRODUCT_EXCHANGED}[data-skuid="${skuId}"] .producttoexchange`)
          .each(function getExchangeData() {
            const currentProduct = $(this);
            data.exchangeItems[skuId].exchangeRelations.push({
              quantity: currentProduct.attr('data-quantityToExchange'),
              replacementSkuId: currentProduct.attr('data-replacementSkuId'),
              returnReason: currentProduct.attr('data-reason')
            });
          });
      });

      sendAExchange($this, data);
      return null;
    })
    .on('click', '.validateRefundButton.enabled', (e) => {
      e.preventDefault();
      // Gestion quantite + raison de retour
      const currentSkuItem = $('.one-product.active').attr('data-skuid');
      const refundItem = $(`.one-product.refund[data-skuid=${currentSkuItem}]`);
      let raison = '';
      let qteTotalItem = 0;

      if (cube.ui.isMobile()) {
        // mobile
        qteTotalItem = $('#product-details-quantity-selector-mobile .quantity-input').val() * 1;
        if (refundItem.length > 0) { // si le produit est dupliqué
          qteTotalItem += refundItem.data('send-quantity-refund') * 1;
        }
        raison = $(REASON_REFUND_MOBILE).selectpicker('val');
      } else {
        // desktop
        qteTotalItem = $('#product-details-quantity-selector .quantity-input').val() * 1;
        if (refundItem.length > 0) { // si le produit est dupliqué
          qteTotalItem += refundItem.data('send-quantity-refund') * 1;
        }
        raison = $('#reason-refund-desktop').selectpicker('val');
      }
      // insert data into DOM
      $(ONE_PRODUCT_ACTIVE).attr('data-send-quantity-refund', qteTotalItem);
      $(ONE_PRODUCT_ACTIVE).attr('data-send-raison', raison);

      // construct map to send
      const data = {
        lines: $this.find(ONE_ITEM),
        returnItems: {}
      };

      data.lines.each((index, element) => {
        const product = $(element);
        const skuId = product.attr('data-skuid');
        data.returnItems[skuId] = {
          id: product.attr('data-skuid'),
          quantityToExchange: product.attr('data-send-quantity-exchange'),
          quantityToReturn: product.attr('data-send-quantity-refund'),
          returnReason: product.attr('data-send-raison'),
          shippingGroupId: product.attr('data-send-shipping-group'),
        };

        $(`${ONE_PRODUCT_EXCHANGED}[data-skuid="${skuId}"] .producttoexchange`)
          .each(function getExchangeData() {
            if (!data.returnItems[skuId].exchangeRelations)
              data.returnItems[skuId].exchangeRelations = [];

            const currentProduct = $(this);
            data.returnItems[skuId].exchangeRelations.push({
              quantity: currentProduct.attr('data-quantityToExchange'),
              replacementSkuId: currentProduct.attr('data-replacementSkuId'),
              returnReason: currentProduct.attr('data-reason')
            });
          });
      });

      sendARefund($this, data);
    })
    // CANCEL A REFUND
    .on('click', '.refund-items .delete-item', function handleClick() {
      const data = {
        lines: $this.find(ONE_ITEM),
        returnItems: {}
      };

      const skuCurrent = $(this).parents('.one-item').attr('data-skuid');
      data.lines.each((index, element) => {
        const product = $(element);
        const skuId = product.attr('data-skuId');
        if (skuCurrent === skuId) {
          data.returnItems[skuId] = {
            id: product.attr('data-skuId'),
            quantityToExchange: product.attr('data-send-quantity-exchange'),
            quantityToReturn: '0',
            returnReason: product.attr('data-send-raison'),
            shippingGroupId: $(element).eq(0).attr('data-send-shipping-group')
          };

          if (!data.returnItems[skuId].exchangeRelations)
            data.returnItems[skuId].exchangeRelations = [];

          $(`${ONE_PRODUCT_EXCHANGED}[data-skuid="${skuId}"] .producttoexchange`)
            .each(function getExchangeData() {
              const currentProduct = $(this);
              data.returnItems[skuId].exchangeRelations.push({
                quantity: currentProduct.attr('data-quantityToExchange'),
                replacementSkuId: currentProduct.attr('data-replacementSkuId'),
                returnReason: currentProduct.attr('data-reason')
              });
            });
        } else {
          data.returnItems[$(element).eq(0).attr('data-skuid')] = {
            id: product.attr('data-skuid'),
            quantityToExchange: product.attr('data-send-quantity-exchange'),
            quantityToReturn: product.attr('data-send-quantity-refund'),
            returnReason: product.attr('data-send-raison'),
            shippingGroupId: product.attr('data-send-shipping-group')
          };

          if (!data.returnItems[skuId].exchangeRelations)
            data.returnItems[skuId].exchangeRelations = [];

          $(`${ONE_PRODUCT_EXCHANGED}[data-skuid="${skuId}"] .producttoexchange`)
            .each(function getExchangeData() {
              const currentProduct = $(this);
              data.returnItems[skuId].exchangeRelations.push({
                quantity: currentProduct.attr('data-quantityToExchange'),
                replacementSkuId: currentProduct.attr('data-replacementSkuId'),
                returnReason: currentProduct.attr('data-reason')
              });
            });
        }
      });

      cancelARefund($this, data);

      return false;
    })
    // CANCEL AN EXCHANGE
    .on('click', '.exchange-items .delete-item', function handleClick() {
      const data = {
        lines: $this.find(ONE_ITEM),
        returnItems: {}
      };
      const skuCurrent = $(this).parents('.one-item').attr('data-skuid');
      const skuExchange = $(this).parents('.one-item').attr('data-skuchanged');
      const skuExchangeQte = $(this).parents('.one-item').attr('data-changedQte');

      // Find and delete blue vignette
      const currentExchange = $(`.one-product.exchange[data-skuid="${skuCurrent}"]`);
      const productCurrent = $(`.one-product:not(.exchange)[data-skuid="${skuCurrent}"]`);

      currentExchange.find(`.producttoexchange[data-replacementskuid="${skuExchange}"]`).remove();

      if (currentExchange.find('.producttoexchange').length === 0) {
        currentExchange.attr('data-send-quantity-exchange', '0');
        productCurrent.attr('data-send-quantity-exchange', '0');
      } else {
        const currentExchangeQte = currentExchange.attr('data-send-quantity-exchange');
        const newQte = currentExchangeQte - skuExchangeQte;
        currentExchange.attr('data-send-quantity-exchange', newQte);
        productCurrent.attr('data-send-quantity-exchange', newQte);
      }

      data.lines.each((index, element) => {
        const product = $(element);
        const skuId = product.attr('data-skuId');
        data.returnItems[$(element).eq(0).attr('data-skuid')] = {
          id: product.attr('data-skuid'),
          quantityToExchange: product.attr('data-send-quantity-exchange'),
          quantityToReturn: product.attr('data-send-quantity-refund'),
          returnReason: product.attr('data-send-raison'),
          shippingGroupId: product.attr('data-send-shipping-group')
        };

        if (!data.returnItems[skuId].exchangeRelations) {
          data.returnItems[skuId].exchangeRelations = [];
        }

        $(`${ONE_PRODUCT_EXCHANGED}[data-skuid="${skuId}"] .producttoexchange`)
          .each(function getExchangeData() {
            const currentProduct = $(this);
            data.returnItems[skuId].exchangeRelations.push({
              quantity: currentProduct.attr('data-quantityToExchange'),
              replacementSkuId: currentProduct.attr('data-replacementSkuId'),
              returnReason: currentProduct.attr('data-reason')
            });
          });
      });

      cancelARefund($this, data);

      return false;
    })
    .on('click', CORE_QUANTITY_BUTTON, function handleClick() {
      window.decathlon.tools.selectorQuantity($(this));
    })
    .on('click', '.select-mini-view a', function handleClick(e) {
      e.preventDefault();
      const currentProduct = $(ONE_PRODUCT_ACTIVE);
      if ($(this).parent().hasClass('active')) {
        return false;
      }
      if (cube.ui.isMobile()) {
        $('.modal').modal('hide');
        $(`#modal-${$(this).attr('href')}`).modal('show');
        currentProduct.addClass('active');
      } else {
        showMiniView($(ONE_PRODUCT_ACTIVE), $(this).attr('href'), $this);
      }
      return true;
    })
    .on('click', '#continueExchangeButton.cta-v2--disabled', () => false)
    .on('click', '#confirmReturnButton', (e) => {
      e.preventDefault();
      confirmReturn($this);
    })
    .on('change', `#reason-refund-desktop, ${REASON_REFUND_MOBILE}`, () => {
      $('.validateRefundButton').addClass('enabled').removeClass('cta-v2--disabled');
    })
    .on('click', '.validateRefundButton.cta-v2--disabled', (e) => {
      e.preventDefault();
    })
    .on('change keyup', '.quantity-selector .quantity-input', function handleClick() {
      window.decathlon.tools.selectorQuantity($(this));
    })
    .on('keypress', '.quantity-selector .quantity-input', (e) => e.charCode >= 48 && e.charCode <= 57 || e.charCode === 0)
    .on('click', '#cancelReturnButton', (e) => {
      e.preventDefault();
      sendCancel($this);
      $('.modal').modal('hide');
    })
    .on('click', '.go-back', (e) => {
      e.preventDefault();
      window.history.back();
    });

  $(document).keyup((e) => {
    if (e.keyCode === 27) {
      closeMiniView();
    }
  });

  $(document).on('hidden.bs.modal', () => {
    closeMiniView();
  });

  $(document).on('shown.bs.modal', () => {
    if ($(MODAL_MAKE_CHOICE).is(':visible')) {
      const quantityInput = $('.quantity-input');
      quantityInput.val('1');
      quantityInput.attr('data-maxquantity', $(ONE_PRODUCT_ACTIVE).data('quantity'));
    }
  });
}

// Method called when changing quantity or return reason for an item.
//
// @param $this Plugin reference.
// @param data Plugin data.
function sendARefund($this, data) {
  const returnItems = Object.values(data.returnItems);

  // If all quantities are equals to 0, no call
  if ($.grep(returnItems, (n) => n.quantityToReturn !== '0').length === 0) {
    // Sets all prices to 0 and disable confirmation button
    reset(data);
  } else {
    // Ajax call
    window.getAjaxHandler()
      .withCaller($this)
      .withUrl(SELECT_ITEM)
      .withParameter('processName', 'Exchange')
      .withParameter(
        'jsonReturnRequest',
        JSON.stringify({ 'returnRequest': { 'shippingGroupList': [{ 'itemList': returnItems }] } }))
      .withComplete(() => {
        reloadCartridges($this);
      })
      .call();
  }
}

// Method called when changing quantity or return reason for an item.
function sendAExchange($this, data) {
  // Building return items Array from data.returnItems Map.
  const exchangeItems = Object.values(data.exchangeItems);

  // If all quantities are equals to 0, no call
  if ($.grep(exchangeItems, (n) => n.quantityToExchange !== '0').length === 0) {
    // Sets all prices to 0 and disable confirmation button
    reset(data);
  } else {
    window.getAjaxHandler()
      .withCaller($this)
      .withUrl(SELECT_ITEM)
      .withParameter('processName', 'Exchange')
      .withParameter(
        'jsonReturnRequest',
        JSON.stringify({ 'returnRequest': { 'shippingGroupList': [{ 'itemList': exchangeItems }] } }))
      .withComplete(() => {
        reloadCartridges($this);
      })
      .call();
  }
}

// Method called when cancel one items
function cancelARefund($this, data) {
  // Building return items Array from data.returnItems Map.
  const returnItems = Object.values(data.returnItems);

  window.getAjaxHandler()
    .withCaller($this)
    .withUrl(SELECT_ITEM)
    .withParameter('processName', 'Exchange')
    .withParameter(
      'jsonReturnRequest',
      JSON.stringify({ 'returnRequest': { 'shippingGroupList': [{ 'itemList': returnItems }] } }))
    .withComplete(() => {
      reloadCartridges($this);
    })
    .call();
}

// Method called when cancel all items
function sendCancel($this) {
  const data = {
    lines: $this.find(ONE_ITEM)
  };
  window.getAjaxHandler()
    .withCaller($this)
    .withUrl(CANCEL_RETURN)
    .withParameter('orderId', $(data.lines).eq(0).attr('data-orderId'))
    .withComplete(() => {
      reloadCartridges($this);
    })
    .call();
  $('#continueExchangeButton').addClass('cta-v2--disabled');
  return false;
}

function confirmReturn($this) {
  const data = {
    lines: $this.find(ONE_ITEM)
  };

  window.getAjaxHandler()
    .withCaller($this)
    .withUrl(CONFIRM_RETURN)
    .withParameter('orderId', $(data.lines).eq(0).attr('data-orderId'))
    .withComplete()
    .call();
  return false;
}

function checkButtonNext() {
  if ($('.one-item').length > 0) {
    $('#continueExchangeButton').removeClass('cta-v2--disabled');
  } else {
    $('#continueExchangeButton').addClass('cta-v2--disabled');
    $('.tooltip-noarticle').tooltip();
  }
}

function reloadCartridges($this) {
  window.reloadCartridgeContentCollection($this, 'reex-selector-content-div-id', undefined);
  window.reloadCartridgeContentCollection($this, 'reex-sumup', undefined, checkButtonNext, undefined);
  $(ALL_PRODUCTS).removeClass(VIEW_OPEN);
  $('.modal-backdrop').remove();
  $('#continueExchangeButton').removeClass('cta-v2--disabled');
}

function closeMiniView() {
  $(ALL_PRODUCTS).removeClass(VIEW_OPEN);
  $('.selector-view').removeClass('active');
  $(ONE_PRODUCT).removeClass('active');
  $(`${VIEW_EXCHANGE} .validateExchangeButton,${MODAL_EXCHANGE} .validateExchangeButton`)
    .removeClass('enabled').addClass('cta-v2--disabled');

  // RAZ raisons mobile & desktop
  $('#reason-refund-desktop').val(0).selectpicker('refresh');
  $(REASON_REFUND_MOBILE).val(0).selectpicker('refresh').selectpicker();
  $('.modal-backdrop').remove();
  $('.validateRefundButton').addClass('cta-v2--disabled').removeClass('enabled');
}

function showMiniView(currentProduct, view, $this) {
  // close all mini-view opened
  $('.selector-view').removeClass('active').removeClass('open-left').removeClass('open-right').removeAttr('style');

  const $_this = currentProduct;
  $_this.addClass('active');

  const quantityToReturn = $(`${ONE_ITEM}.active`).attr('data-send-quantity-refund');
  const quantityCurrentItem = $('#selector-view-choice .quantity-input').val();

  if (view === 'selector-view-refund-choice') {
    getPriceCurrentItem($this, quantityCurrentItem, quantityToReturn);
  }

  // update quantity selector & select
  const quantityInput = $('.quantity-input');
  quantityInput.attr('data-maxquantity', $_this.data('quantity'));
  $('.selectpicker').selectpicker('refresh');

  if (quantityInput.data('maxquantity') === 1) {
    $('.quantity-more').attr('disabled', 'disabled');
    quantityInput.attr('readonly', 'readyonly');
    quantityInput.attr('disabled', 'disabled');
  }

  // update quantity selector & select
  const returnQuantityInput = $('#modal-selector-view-return-choice .quantity-input');
  returnQuantityInput.data('maxquantity', $('.one-product.active').data('quantity'));
  $('#reason-refund-mobile .selectpicker').selectpicker('refresh');

  if (returnQuantityInput.data('maxquantity') === 1) {
    $('.quantity-more').attr('disabled', 'disabled');
    quantityInput.attr('readonly', 'readyonly');
    quantityInput.attr('disabled', 'disabled');
  } else {
    $('.quantity-more').removeAttr('disabled');
    quantityInput.removeAttr('readonly');
    quantityInput.removeAttr('disabled');
  }

  // Construct my mini view
  const ongletWidth = 305; // en px
  const oneProductWidth = $(SELECTOR_CONTAINER).find('.one-product:first-child').outerWidth(); // en px
  const ongletHeight = $(SELECTOR_CONTAINER).find('.one-product:first-child').outerHeight() - 6; // en px, 4px pour la marge
  const oneProductPosition = $_this.position(); // object
  const oneProductPositionTop = oneProductPosition.top; // en px
  const oneProductPositionLeft = oneProductPosition.left; // en px

  let ongletLeft = 0; // en px
  let ongletTop = 0; // en px

  $(ALL_PRODUCTS).addClass(VIEW_OPEN);

  let classList = null;
  if ($_this.index() % 4 === 0 || $_this.index() % 4 === 1) {
    // afficher le volet à droite du bloc
    classList = 'active open-left';
    ongletTop = oneProductPositionTop;
    ongletLeft = oneProductPositionLeft + oneProductWidth - 7; // marge de 7px + 20px pour le triangle
  } else {
    // afficher le volet à gauche du bloc
    classList = 'active open-right';
    ongletTop = oneProductPositionTop;
    ongletLeft = oneProductPositionLeft - ongletWidth + 7; // marge de 7px + 20px pour le triangle
  }

  $(`#${view}`).addClass(classList).css({
    'top': `${ongletTop}px`,
    'left': `${ongletLeft}px`,
    'width': `${ongletWidth}px`,
    'height': `${ongletHeight}px`
  });
}

function checkButtonState() {
  const btnValidateExchange = $(`${VIEW_EXCHANGE} .validateExchangeButton,${MODAL_EXCHANGE} .validateExchangeButton`);
  if ($('.exchange-size--current .exchange-size__list-container').hasClass('selected')
    && $('.reason-exchange').hasClass('selected')) {
    btnValidateExchange.removeClass('cta-v2--disabled').addClass('enabled');
  } else if (btnValidateExchange.hasClass('enabled')) {
    btnValidateExchange.removeClass('enabled').addClass('cta-v2--disabled');
  }
}

function getPriceCurrentItem($this, quantityCurrentItem, quantityToReturn) {
  const data = {
    lines: $this.find(AN_ITEM),
    returnItems: {}
  };

  const skuCurrent = $(ONE_PRODUCT_ACTIVE).attr('data-skuid');
  data.lines.each((index, element) => {
    const skuId = $(element).eq(0).attr('data-skuid');
    if (skuCurrent === skuId) {
      data.returnItems[skuId] = {
        id: skuId,
        quantityToExchange: $(element).eq(0).attr('data-send-quantity-exchange'),
        quantityToReturn: quantityCurrentItem,
        returnReason: 'otherReason',
        shippingGroupId: $(element).eq(0).attr('data-send-shipping-group')
      };

      $(`${ONE_PRODUCT_EXCHANGED}[data-skuid="${skuId}"] .producttoexchange`)
        .each(function getExchangeData() {
          if (!data.returnItems[skuId].exchangeRelations)
            data.returnItems[skuId].exchangeRelations = [];

          const currentProduct = $(this);
          data.returnItems[skuId].exchangeRelations.push({
            quantity: currentProduct.attr('data-quantityToExchange'),
            replacementSkuId: currentProduct.attr('data-replacementSkuId'),
            returnReason: currentProduct.attr('data-reason')
          });
        });
    } else {
      data.returnItems[skuId] = {
        id: skuId,
        quantityToExchange: $(element).eq(0).attr('data-send-quantity-exchange'),
        quantityToReturn: $(element).eq(0).attr('data-send-quantity-refund'),
        returnReason: $(element).eq(0).attr('data-send-raison'),
        shippingGroupId: $(element).eq(0).attr('data-send-shipping-group')
      };

      $(`${ONE_PRODUCT_EXCHANGED}[data-skuid="${skuId}"] .producttoexchange`)
        .each(function getExchangeData() {
          if (!data.returnItems[skuId].exchangeRelations) {
            data.returnItems[skuId].exchangeRelations = [];
          }

          const currentProduct = $(this);
          data.returnItems[skuId].exchangeRelations.push({
            quantity: currentProduct.attr('data-quantityToExchange'),
            replacementSkuId: currentProduct.attr('data-replacementSkuId'),
            returnReason: currentProduct.attr('data-reason')
          });
        });
    }
  });
  const returnItems = Object.values(data.returnItems);

  window.getAjaxHandler()
    .withCaller($this)
    .withUrl(PREVIEW_SELECT_ITEM)
    .withParameter('skuId', skuCurrent)
    .withParameter('oldQty', quantityToReturn)
    .withParameter(
      'jsonReturnRequest',
      JSON.stringify({ 'returnRequest': { 'shippingGroupList': [{ 'itemList': returnItems }] } }))
    .withSuccess((caller, res) => {
      if (res && res.responseTO.data.data.amountToRefund.formattedAmount) {
        $('.price-refund').html(res.responseTO.data.data.amountToRefund.formattedAmount);
      }
    })
    .call();
}

// Updates line price.
//
// @param data Plugin data.
// @param rId Return item id to change.
// @param amount New amount.
// @param currency New currency.
function updatePrice(data, rId, amount) {
  if (undefined !== data) {
    amountFormat(
      data.lines
        .filter('[{0}="{1}"]'.format('data-skuid', rId))
        .find('.price .subtotal '),
      amount);
  }
}

// Resets all amount and total return quantity to 0.
function reset(data) {
  // Updates all prices.
  if (undefined !== data) {
    data.lines.each(function updateLine() {
      updatePrice(data, $(this).attr('data-skuid'), 0);
    });
  }
  // Updates footer.
  window.throwEvent(window.Events.RETURN_TOTAL_UPDATED, 0, 0);
}

function amountFormat($holder, amount) {
  if ($holder.length !== 0 && undefined !== amount) {
    $holder.text($holder.text().replace(/[0-9,.]/g, '') + amount.toFixed(2).toLocaleString());
  }
}



// WEBPACK FOOTER //
// ./src/customer/account/returns/product-return.js